/** @jsxImportSource @emotion/react */
import type { ReactElement } from 'react';
import { useLocation } from 'react-router-dom';
import { parse } from 'qs';
import { ODSLoginPortal } from 'bc-ods';
import { resetPasswordWithCode } from 'api-client/accounts';
import ResetForm from './ResetForm';
import { includeBasePath } from 'utils/url-utils';

function Reset(): ReactElement {
  const { search: queryString } = useLocation();
  const { code } = parse(queryString, { ignoreQueryPrefix: true });

  if (!code) {
    window.location.href = includeBasePath(`/login`);
    return <div />;
  }

  const resetPassword = async (password) => {
    const { data } = await resetPasswordWithCode(code.toString(), password);
    return data;
  };

  return (
    <ODSLoginPortal>
      <ResetForm resetPassword={resetPassword} />
    </ODSLoginPortal>
  );
}

export default Reset;
